import { useMutation, useQueryClient } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  postFavoritePairing,
  type PostFavoritePairingParams,
} from '@hungryroot/rest/api/v2/customers/[id]/favorite_pairings/post/post-api-v2-customers-customer_id-favorite_pairings';
import { invalidateFavoritePairings } from './useFavoritePairings';

export function usePostFavoritePairing() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (queryParams: PostFavoritePairingParams) => {
      const res = await postFavoritePairing(queryParams);

      if (res.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }
      return res.data;
    },
    onSuccess: () => {
      invalidateFavoritePairings(queryClient);
    },
  });
}
